// サンプル請求・お問い合わせのフォーム（Issue #106）の API の形。サーバー（src/server/sample-form/）と hook（src/hooks/sample-form.ts）で共有する。
//
//   POST /api/sample-form  ← SampleFormRequest → 200 { ok: true } / 400 { ok: false, error }
//
// ★受ける項目はこの型の分だけ（決め打ち）。旧の口（OppSites `POST api/Form`）は JSON を SampleFormPost に一括でバインドしていて、
//   B2発送番号・メール発送状態・メール送信回数・FormPostStatus まで外から書けた。新では受けない。
// ★メールは送らない。控えは Core2 の定時（1 分ごと）が、旧の口の行も新の口の行も「控えメール送信日時 IS NULL」で拾って送る
//   （zio3/OppSiteCore2#702。受付元は見ない）。受付元 = 1 は新旧の数え分け用。

/** 対象店（#105 の棚卸しの 11 店。閉鎖した 7・8・13 は入れない）。ページは shared/contact-pages.ts の飛ばし先と同じ */
export const SAMPLE_FORM_SITES: number[] = [1, 2, 3, 4, 6, 9, 10, 11, 14, 15, 16]

/** フォームの箱（data-wu-app。Issue #123 / #130。旧の ng-app は見ない）。hooks.ts の when と hook 本体で同じものを使う */
export const SAMPLE_FORM_APP_SELECTOR = '[data-wu-app="sample-form"]'

/** サンプル配送の指定。DB の SampleFormPosts.Delivery（int）。ページの radio の value は名前（none / free / pay） */
export const DELIVERY = { none: 0, free: 1, pay: 2 } as const
export type DeliveryName = keyof typeof DELIVERY

/** 1 項目の長さの上限（受付として。列はどれも nvarchar(max)） */
export const SAMPLE_FORM_TEXT_MAX = 4000

export interface SampleFormRequest {
  siteInfoId: number
  name: string
  company?: string | null
  postCode: string
  address: string
  mail: string
  phoneNumber: string
  /** 用途（紙ストロー 9・b-futou 10 のページだけ欄がある） */
  purpose?: string | null
  /** お問い合わせ内容。delivery = none なら必須 */
  body?: string | null
  delivery: DeliveryName
  /** 配送時間帯（有料のときだけ意味がある。旧と同じく送られたまま入れる） */
  arrive?: string | null
  /** 請求サンプル。delivery が none 以外なら必須。none なら空にして入れる（旧と同じ） */
  sample?: string | null
  /** 画面の document.referrer */
  refUrl?: string | null
  /** ハニーポット（人には見えない欄）。埋まっていれば bot として黙って捨てる */
  website?: string
}

/**
 * 閲覧履歴から請求サンプルを入れる口（Issue #107）
 *
 *   GET /api/sample-form/history-products?siteInfoId=1&ids=新しい順,カンマ区切り → 200 { ok: true, items: ["商品名[型番]", …] }
 *
 * 対象は閲覧履歴の radio があった 8 店（14・15・16 は問い合わせだけのページで、サンプル欄が無い）。
 */
export const HISTORY_SITES: number[] = [1, 2, 3, 4, 6, 9, 10, 11]
/** 受ける ids の数の上限（EXT・SampleSkip で落ちる分を見込んで、入れる件数より多めに受ける） */
export const HISTORY_IDS_MAX = 20
/** 欄に入れる件数（フォームの「5 点まで」） */
export const HISTORY_ITEMS_MAX = 5

export interface HistoryProductsResponse {
  ok: boolean
  /** 「商品名[型番]」を新しい順に HISTORY_ITEMS_MAX 件まで（旧 api/Product と同じ形） */
  items?: string[]
}

/**
 * 画面で送信に失敗したことを知らせる口（ChatBan #332）。店と理由だけを受けて、サーバーのログに 1 行出す。
 *
 *   POST /api/sample-form/client-error  本文 { siteInfoId, reason }（Content-Type: text/plain。プリフライトを飛ばさないため）→ 204
 *
 * reason は network（届かなかった）か http-NNN（口が NNN を返した）だけ。入力の中身は送らない。
 */
export const CLIENT_ERROR_PATH = '/client-error'
export const CLIENT_ERROR_REASON = /^(network|http-[1-5]\d\d)$/
export interface ClientErrorReport {
  siteInfoId: number
  reason: string
}
